import { Promise } from 'es6-promise';
import { IServerResponse, InitialisationHelper, EModalType } from './';
import { TIMEOUT_WARNING_DELAY, TIMEOUT_DELAY } from '../constants'
import store from '../store/store';
import types from '../store/types';

declare var $;

let config = { clientId: '' };
let resourceId = "";

const UNSPECIFIED_ERROR: IServerResponse = {
    data: null,
    errorMessages: null,
    isValid: false,
    error: {
        code: 0,
        message: 'Unspecified error'
    }
};

export const post = (url: string, data: any, headers: any, isFormData: boolean = false, isFile: boolean = false): Promise<any> => {
    return sendRequest(url, 'POST', data, headers, true, isFormData, isFile);
};

export const del = (url: string, data: any, headers: any, isFormData: boolean = false, isFile: boolean = false): Promise<any> => {
    return sendRequest(url, 'DELETE', data, headers, true, isFormData, isFile);
};
export const patch = (url: string, data: any, headers: any, isFormData: boolean = false, isFile: boolean = false): Promise<any> => {
    return sendRequest(url, 'PATCH', data, headers, true, isFormData, isFile);
};

export const get = (url: string, async: boolean = true): Promise<any> => {
    return sendRequest(url, 'GET', {});
};

const GetAuthTokenFromCookie = (): string => {
    if (config && config.clientId) {
        var authContext = new AuthenticationContext(config);
        return authContext.getCachedToken(resourceId);
    }

    return null;
}

const sendRequest = (url: string, method: string, data: any, headers: any = null, async: boolean = true, isFormData: boolean = false, isFile: boolean = false): Promise<any> => {

    let promise = new Promise((resolve, reject) => {

        let xhr = new XMLHttpRequest();
        xhr.open(method, url, async);
        if (isFile)
            xhr.responseType = "arraybuffer";

        if (InitialisationHelper.ConfigSettings) {

            Authenticate(InitialisationHelper.ConfigSettings).then((authToken) => {
                xhr.setRequestHeader("Authorization", "Bearer " + authToken);
                // Set the headers
                for (let header in headers) {
                    xhr.setRequestHeader(header, headers[header]);
                }

                // Success and error functions
                xhr.onreadystatechange = function () {

                    if (xhr.readyState === XMLHttpRequest.DONE && (xhr.status === 200 || xhr.status === 400)) {
                        if (isFile) {
                            let fileName: string = xhr.getResponseHeader("Content-FileName");
                            if (!fileName) {
                                fileName = "export.zip";
                            }
                            resolve({ file: xhr.response, filename: fileName })
                        }
                        else {
                            resolve(JSON.parse(xhr.response));
                        }
                    }

                    else if (xhr.readyState === XMLHttpRequest.DONE) {
                        let response = xhr.response ? JSON.parse(xhr.response) : UNSPECIFIED_ERROR;
                        var authContext = config && config.clientId ? new AuthenticationContext(config) : null;
                        reject(response);
                    }

                };

                // Send the request
                if (!isFormData) {
                    if (method === 'DELETE') {
                        console.log('delete req ---> ', JSON.stringify(data));
                        xhr.send(data ? JSON.stringify(data) : null)
                    }
                    else {
                        xhr.send(data ? JSON.stringify(data) : null);

                    }
                }
                else {
                    xhr.send(data);
                }

            });

        }

        else {

            var authToken = GetAuthTokenFromCookie();
            if (authToken) {
                xhr.setRequestHeader("Authorization", "Bearer " + authToken);
            }

            // Set the headers
            for (let header in headers) {
                xhr.setRequestHeader(header, headers[header]);
            }

            // Success and error functions
            xhr.onreadystatechange = function () {

                if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
                    resolve(JSON.parse(xhr.response));
                }

                else if (xhr.readyState === XMLHttpRequest.DONE) {
                    let response = xhr.response ? JSON.parse(xhr.response) : UNSPECIFIED_ERROR;
                    var authContext = config && config.clientId ? new AuthenticationContext(config) : null;
                    reject(response);
                }

            };

            // Send the request
            xhr.send(data ? JSON.stringify(data) : null);

        }

    });

    return promise;

};


export const Authenticate = (connectionSettings): Promise<any> => {
    config = connectionSettings.config;
    resourceId = connectionSettings.resourceId;

    var authToken = GetAuthTokenFromCookie();
    var authContext = new AuthenticationContext(config);
    var isCallback = authContext.isCallback(window.location.hash);

    if (isCallback) {
        authContext.handleWindowCallback();
    }

    let promise = new Promise((resolve, reject) => {
        var user = authContext.getCachedUser();

        if (user) {
            authContext.acquireToken(resourceId, function (err, token) {
                if (err) {
                    if (err.indexOf('AADSTS50058') >= 0) {
                        authContext.login();
                    }
                    else {
                        alert(err);
                        reject(err);
                    }
                }
                else {
                    resetTimeoutWarning();
                    resolve(token);
                }
            });

        }
        else {
            authContext.login();
        }
    });
    return promise;
};

export const CancelTimeoutWarning = () => {

    let timeoutWarningId = store.getState().authenticationState.timeoutWarningId;

    if (timeoutWarningId) {
        window.clearTimeout(timeoutWarningId);
        setTimeoutWarningId(null);
    }

};

export const RenewToken = () => {

    if (InitialisationHelper.ConfigSettings) {
        Authenticate(InitialisationHelper.ConfigSettings);
    }

}

export const Logout = () => {
    if (InitialisationHelper.ConfigSettings) {
        var authContext = new AuthenticationContext(InitialisationHelper.ConfigSettings.config);
        authContext.logOut();
    }
}

let setTimeoutWarningId = (timeoutWarningId: number) => {

    store.dispatch({
        type: types.SET_TIMEOUT_WARNING_ID,
        timeoutWarningId: timeoutWarningId
    });

};

let resetTimeoutWarning = () => {

    CancelTimeoutWarning();

    let timeoutWarningId = window.setTimeout(() => {
        timeoutWarning();
    }, TIMEOUT_WARNING_DELAY); // TODO: replace time period with parameter from server

    setTimeoutWarningId(timeoutWarningId);

};

let timeoutWarning = () => {

    CancelTimeoutWarning();

    store.dispatch({
        type: types.TOGGLE_DIALOG,
        openModal: EModalType.AuthenticationWarning
    });

    let timeoutWarningId = window.setTimeout(() => {
        timeout();
    }, TIMEOUT_DELAY); // TODO: replace time period with parameter from server

    setTimeoutWarningId(timeoutWarningId);

};

let timeout = () => {

    if (InitialisationHelper.ConfigSettings && InitialisationHelper.ConfigSettings.config) {

        store.dispatch({
            type: types.SET_TIMEOUT_PASSED,
            timeoutPassed: true
        });

        var authContext = new AuthenticationContext(InitialisationHelper.ConfigSettings.config);
        authContext.clearCache();

        $('<iframe>', {
            src: 'https://login.microsoftonline.com/logout.srf',
            id: 'logoutFrame',
            frameborder: 0,
            scrolling: 'no'
        }
        ).appendTo('#root');

    }

};


// WEBPACK FOOTER //
// ./source/ts/helpers/ajax.ts